import React, { useState, useEffect } from "react";
import axios from "axios";
import "./Datatable.css";
import adminuser from "./images/admin_user.png";
import CONFIG from "./config";

const AdminUserProfile = () => {
  const [profileData, setProfileData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const response = await axios.get(`${CONFIG.BASE_URL}/auth/signup`);

      if (response.data.length > 0) {
        setProfileData(response.data[0]); // Assuming the first user is the admin
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <p>Loading...</p>;
  }

  return (
    <div className="custom-table-container">
      <div className="admin_userprofile">
        <div className="card w-100 radius-10 card_blue col-md-12">
          <div className="card-body p-0 w-100">
            <h4 className="adminblocktitle text-left">Admin Profile</h4>
            <div className="adminpro_details">
              <div className="adminuser_header d-flex">
                <div className="photpoint d-flex">
                  <div className="adminpic">
                    <img
                      src={adminuser}
                      className="p-1 border"
                      width="45"
                      height="45"
                      alt="Admin"
                    />
                  </div>
                  <div className="admin_name">
                    <div className="lable_title1">{profileData?.user_name}</div>
                  </div>
                </div>
                <div className="admin_loginstatus ps-auto d-flex">
                  <p className="status_lable">Login Status</p>
                  <p className="status_color">
                    <b>{profileData?.is_active ? "Active" : "Inactive"}</b>
                  </p>
                </div>
              </div>

              <div className="adminuser_details">
                <div className="lable_title2">Contact Information</div>
                <p className="d-flex">
                  <label>Phone</label>
                  <span>:</span>
                  <p>{profileData?.phone}</p>
                </p>
                <p className="d-flex">
                  <label>Email</label>
                  <span>:</span>
                  <p>{profileData?.email}</p>
                </p>

                <div className="lable_title2">Account Settings</div>
                <p className="d-flex">
                  <label>Created at</label>
                  <span>:</span>
                  <p>{new Date(profileData?.createdAt).toLocaleString()}</p>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminUserProfile;
